<template>
  <div class="liftDetail">
    <div class="titleWrap">
      <div class="setTitle">{{ liftSN }}</div>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/villageDetail?id=' + villageId + '&villageName=' + encodeURI(encodeURI(villageName)) + '&villageAddress=' + encodeURI(encodeURI(villageAddress)) }">{{ villageName }}</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/buildingDetail?buildingName=' + encodeURI(encodeURI(buildingName)) + '&villageId=' + villageId + '&villageName=' + encodeURI(encodeURI(villageName)) + '&villageAddress=' + encodeURI(encodeURI(villageAddress)) }">{{ buildingName }}栋</el-breadcrumb-item>
        <el-breadcrumb-item>电梯详情</el-breadcrumb-item>
      </el-breadcrumb>
      <el-button class="myBtn" type="primary" plain size="small" v-if="orgId !== ''" :disabled="delStatus" @click="remove" style="margin-left: 10px;">批量删除</el-button>
      <el-button class="myBtn" type="primary" size="small" v-if="orgId !== ''" @click="add">新增</el-button>
      <div class="clearfix"></div>
    </div>
    <el-main class="tableWrap">
      <el-select class="select" v-model="dataTypeValue" filterable clearable size="small" placeholder="资料类别">
        <el-option v-for="item in dataTypeList" :key="item.key" :label="item.value" :value="item.key"></el-option>
      </el-select>
      <el-input class="input" v-model.trim="fileName" size="small" placeholder="文件名称"></el-input>
      <el-input class="input" v-model.trim="creator" size="small" placeholder="创建人"></el-input>
      <el-button class="searchBtn" type="primary" size="small" @click="search"><i class="el-icon-search"></i></el-button>
      <div class="clearfix"></div>
      <el-table :data="fileAttr" class="list" @selection-change="selectFile">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column type="index" label="序号" width="80" :index="indexMethod" :align="align"></el-table-column>
        <el-table-column prop="fileType" label="资料类别" min-width="180" :align="align">
          <template slot-scope="scope">
            {{ fileType(scope.row.fileType) }}
          </template>
        </el-table-column>
        <el-table-column prop="filename" label="文件名称" min-width="180" :align="align"></el-table-column>
        <el-table-column prop="uploadTime" label="更新时间" min-width="180" :align="align">
          <template slot-scope="scope">
            {{ createTime(scope.row.uploadTime) }}
          </template>
        </el-table-column>
        <el-table-column prop="maintainTime" label="本次保养时间" min-width="180" :align="align">
          <template slot-scope="scope">
            {{ byTime(scope.row.maintainTime) }}
          </template>
        </el-table-column>
        <el-table-column prop="annualTime" label="本次年检时间" min-width="180" :align="align">
          <template slot-scope="scope">
            {{ njTime(scope.row.annualTime) }}
          </template>
        </el-table-column>
        <el-table-column prop="creator" label="创建人" min-width="180" :align="align"></el-table-column>
        <el-table-column prop="remark" label="备注" min-width="180" :align="align">
          <template slot-scope="scope">
            {{ notData(scope.row.remark) }}
          </template>
        </el-table-column>
        <el-table-column fixed="right" min-width="100" label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" v-if="orgId !== ''" @click="edit(scope.row.id)">编辑</el-button>
            <el-button type="text" size="small" @click="download(scope.row.fileId)">下载</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background layout="total, sizes, prev, pager, next, jumper" :current-page.sync="fileCurr" :page-sizes="[10, 20, 50]" :page-size="fileSize" :total="fileTotal" @current-change="fileCurrChange" @size-change="fileSizeChange"></el-pagination>
    </el-main>
    <!-- 新增编辑电梯文件弹出层 -->
    <el-dialog :visible.sync="dialog" :title="title" width="500px" :close-on-click-modal="false" @close="notBtn">
      <el-form ref="form" :model="form" :rules="rules" label-width="100px" size="small">
        <el-form-item label="资料类别" prop="fileType">
          <el-select v-model="form.fileType" filterable clearable placeholder="资料类别" @change="changeFileType">
            <el-option v-for="item in form.fileTypeList" :key="item.key" :label="item.value" :value="item.key"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="保养时间" prop="byTime" v-if="form.fileType === 2">
          <el-date-picker v-model="form.byTime" type="date" placeholder="保养时间" :editable="false" :picker-options="setMinTime"></el-date-picker>
        </el-form-item>
        <el-form-item label="年检时间" prop="njTime" v-if="form.fileType === 1">
          <el-date-picker v-model="form.njTime" type="date" placeholder="年检时间" :editable="false" :picker-options="setMinTime"></el-date-picker>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model.trim="form.fileMark" type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" placeholder="备注"></el-input>
        </el-form-item>
        <el-form-item label="文件" :required="true">
          <el-upload ref="upload" action="" :multiple="false" :auto-upload="false" :limit="1" :file-list="form.fileList" :on-change="upload" :on-exceed="explainFile" :on-remove="delFile">
            <el-button slot="trigger" size="small" type="primary">上传文件</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="notBtn">取 消</el-button>
        <el-button size="small" type="primary" :loading="loading" @click="okBtn">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'LiftDetail',
  data () {
    return {
      align: this.$align, // 表格对齐方式
      setMinTime: { // 日期大于当前
        disabledDate: time => {
          return time.getTime() < Date.now() - 24 * 60 * 60 * 1000
        }
      },
      villageId: '', // 小区Id
      orgId: this.$store.state.user.villageId, // 登录时的小区Id
      villageName: '', // 小区名称
      villageAddress: '', // 小区地址
      buildingName: '', // 楼宇名称
      liftId: '', // 电梯Id
      liftSN: '', // 电梯SN
      dataTypeValue: '', // 资料类别下拉菜单选中value
      dataTypeList: [], // 资料类别下拉菜单
      fileName: '', // 文件名称查询输入框
      creator: '', // 创建人查询输入框
      delStatus: true, // 批量删除按钮的状态
      fileAttr: [], // 电梯文件列表
      fileTotal: 0, // 电梯文件总数
      fileSize: 10, // 电梯文件每页条数
      fileCurr: 1, // 电梯文件当前页数
      selectFileArr: [], // 选中的电梯文件数组
      dialog: false, // 电梯文件弹出层状态
      title: '', // 电梯文件弹出层标题
      loading: false, // 电梯文件弹出层确定按钮loading
      form: {
        fileRecordId: '', // 文件记录Id
        fileType: '', // 资料类别下拉菜单选中value
        fileTypeList: [], // 资料类别数组
        byTime: '', // 保养时间
        njTime: '', // 年检时间
        fileMark: '', // 备注
        fileId: '', // 文件Id
        fileName: '', // 文件名称
        file: '', // 文件
        fileList: [] // 上传的文件列表
      },
      rules: {
        fileType: [
          {
            required: true,
            message: '请选择资料类别',
            trigger: 'change'
          }
        ],
        byTime: [
          {
            type: 'date',
            required: true,
            message: '请选择保养时间',
            trigger: 'change'
          }
        ],
        njTime: [
          {
            type: 'date',
            required: true,
            message: '请选择年检时间',
            trigger: 'change'
          }
        ]
      }
    }
  },
  mounted () {
    // 小区Id
    this.villageId = this.$route.query.villageId
    // 小区名称
    this.villageName = decodeURI(decodeURI(this.$route.query.villageName))
    // 小区地址
    this.villageAddress = decodeURI(decodeURI(this.$route.query.villageAddress))
    // 楼宇名称
    this.buildingName = decodeURI(decodeURI(this.$route.query.buildingName))
    // 电梯Id
    this.liftId = this.$route.query.liftId
    // 电梯SN
    this.liftSN = this.$route.query.liftSN

    // 获取资料类别下拉框数据
    this.dataTypeList = [
      {
        key: 1,
        value: '年检记录'
      },
      {
        key: 2,
        value: '保养记录'
      },
      {
        key: 3,
        value: '其他文档'
      }
    ]
    this.form.fileTypeList = [
      {
        key: 1,
        value: '年检记录'
      },
      {
        key: 2,
        value: '保养记录'
      },
      {
        key: 3,
        value: '其他文档'
      }
    ]

    // 获取电梯文件列表
    this.getFileList(this.fileCurr, this.fileSize)
  },
  methods: {
    getFileList (page, size) {
      this.$http.get(this.$api.lift_file_list, {
        params: {
          pageNum: page,
          pageSize: size,
          liftId: this.liftId,
          fileType: this.dataTypeValue,
          filename: this.fileName,
          creator: this.creator
        }
      }).then((res) => {
        let data = res.data

        if (data.success) {
          this.fileAttr = data.data.list
          this.fileTotal = data.data.total
          this.fileSize = size
          this.fileCurr = page
        } else {
          this.$message({
            type: 'error',
            message: data.msg,
            duration: 1000
          })
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    search () {
      this.getFileList(1, this.fileSize)
    },
    add () {
      this.dialog = true
      this.title = '新增电梯文件'
    },
    edit (id) {
      this.$http.get(this.$api.lift_file_detail, {
        params: {
          id: id
        }
      }).then((res) => {
        let data = res.data

        if (data.success) {
          this.form.fileRecordId = id
          this.form.fileId = data.data.fileId
          this.form.fileName = data.data.filename
          this.form.fileType = data.data.fileType
          if (data.data.maintainTime === null || data.data.maintainTime === '') {
            this.form.byTime = ''
          } else {
            this.form.byTime = new Date(data.data.maintainTime.substr(0, 4) + '-' + data.data.maintainTime.substr(5, 2) + '-' + data.data.maintainTime.substr(8, 2))
          }
          if (data.data.annualTime === null || data.data.annualTime === '') {
            this.form.njTime = ''
          } else {
            this.form.njTime = new Date(data.data.annualTime.substr(0, 4) + '-' + data.data.annualTime.substr(5, 2) + '-' + data.data.annualTime.substr(8, 2))
          }
          this.form.fileMark = data.data.remark
          this.form.fileList.push({
            name: data.data.filename,
            url: ''
          })
          this.dialog = true
          this.title = '编辑电梯文件'
        } else {
          this.$message({
            type: 'error',
            message: data.msg,
            duration: 1000
          })
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    download (id) {
      // this.$http({
      //   method: 'get',
      //   url: this.$api.file_download + '?id=' + id,
      //   responseType: 'arraybuffer'
      // }).then((res) => {
      //   let blob = new Blob([res.data], {type: 'application/actet-stream;charset=utf-8'})
      //   let contentDisposition = res.headers['content-disposition']
      //   let patt = new RegExp('filename=([^;]+\\.[^\\.;]+);*')
      //   let result = patt.exec(contentDisposition)
      //   let filename = result[1]
      //   let downloadElement = document.createElement('a')
      //   let href = window.URL.createObjectURL(blob)
      //   downloadElement.style.display = 'none'
      //   downloadElement.href = href
      //   downloadElement.download = decodeURI(filename)
      //   document.body.appendChild(downloadElement)
      //   downloadElement.click()
      //   document.body.removeChild(downloadElement)
      //   window.URL.revokeObjectURL(href)
      // }).catch((err) => {
      //   console.log(err)
      // })
      window.open(this.$api.file_download + '?id=' + id)
    },
    changeFileType (val) {
      this.form.byTime = ''
      this.form.njTime = ''
    },
    upload (file, fileList) {
      this.form.file = file.raw
      this.form.fileList.push({
        name: file.name,
        url: ''
      })
      let formData = new FormData()
      formData.append('file', this.form.file)

      this.$http({
        method: 'post',
        url: this.$api.lift_file_upload,
        data: formData
      }).then((res) => {
        let data = res.data

        if (data.success) {
          this.form.fileId = data.data.split('id=')[1]
          this.form.fileName = file.name
        } else {
          this.form.fileList = []
          this.$message({
            type: 'error',
            message: data.msg,
            duration: 1000
          })
        }
      }).catch((err) => {
        this.form.fileList = []
        console.log(err)
      })
    },
    explainFile (file, fileList) {
      this.$message({
        message: '已有文件，请先删除现有文件',
        type: 'warning',
        duration: 1000
      })
    },
    delFile (file, fileList) {
      this.form.file = ''
      this.form.fileList = []
      this.form.fileId = ''
      this.form.fileName = ''
    },
    selectFile (selection) {
      if (selection.length > 0) {
        this.delStatus = false
        this.selectFileArr = []
        for (let i = 0; i < selection.length; i++) {
          this.selectFileArr.push(selection[i].id)
        }
      } else {
        this.delStatus = true
      }
    },
    remove () {
      this.$confirm('是否删除电梯文件?', '提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let formData = new FormData()
        let ids = this.selectFileArr.join()
        formData.append('ids', ids)

        this.$http({
          method: 'post',
          url: this.$api.lift_file_remove,
          data: formData
        }).then((res) => {
          let data = res.data

          if (data.success) {
            this.$message({
              message: '电梯文件已删除',
              type: 'success',
              duration: 1000
            })
            this.getFileList(1, this.fileSize)
          } else {
            this.$message({
              type: 'error',
              message: data.msg,
              duration: 1000
            })
          }
        }).catch((err) => {
          console.log(err)
        })
      }).catch(() => {})
    },
    notBtn () {
      this.loading = false
      this.form.fileRecordId = ''
      this.form.fileId = ''
      this.form.fileName = ''
      this.form.file = ''
      this.form.fileList = []
      this.$refs.form.resetFields()
      this.dialog = false
      this.form.fileType = ''
      this.form.byTime = ''
      this.form.njTime = ''
      this.form.fileMark = ''
    },
    okBtn () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true

          let formData = new FormData()
          formData.append('orgId', this.villageId)
          formData.append('liftId', this.liftId)
          formData.append('id', this.form.fileRecordId)
          formData.append('fileType', this.form.fileType)
          formData.append('uploadTime', this.$date4(new Date().getTime()))
          if (this.form.byTime !== '' && this.form.byTime !== null) {
            formData.append('maintainTime', this.$date1(this.form.byTime.toString()) + ' 00:00:00')
          }
          if (this.form.njTime !== '' && this.form.njTime !== null) {
            formData.append('annualTime', this.$date1(this.form.njTime.toString()) + ' 00:00:00')
          }
          formData.append('remark', this.form.fileMark)

          if (this.form.fileRecordId === '') {
            if (this.form.fileList.length === 0) {
              this.$message({
                type: 'error',
                message: '文件不能为空',
                duration: 1000
              })
              this.loading = false
            } else {
              formData.append('fileId', this.form.fileId)
              formData.append('filename', this.form.fileName)

              this.$http({
                method: 'post',
                url: this.$api.lift_file_add,
                data: formData
              }).then((res) => {
                let data = res.data

                if (data.success) {
                  this.$message({
                    message: '新增电梯文件成功',
                    type: 'success',
                    duration: 1000
                  })
                  this.notBtn()
                  this.getFileList(this.fileCurr, this.fileSize)
                } else {
                  this.$message({
                    type: 'error',
                    message: data.msg,
                    duration: 1000
                  })
                }
                this.loading = false
              }).catch((err) => {
                this.loading = false
                console.log(err)
              })
            }
          } else {
            if (this.form.fileList.length === 0) {
              this.$message({
                type: 'error',
                message: '文件不能为空',
                duration: 1000
              })
              this.loading = false
            } else {
              if (this.form.file === '') {
                formData.append('fileId', this.form.fileId)
                formData.append('filename', this.form.fileName)
                this.$http({
                  method: 'post',
                  url: this.$api.lift_file_edit,
                  data: formData
                }).then((res) => {
                  let data = res.data

                  if (data.success) {
                    this.$message({
                      message: '编辑电梯文件成功',
                      type: 'success',
                      duration: 1000
                    })
                    this.notBtn()
                    this.getFileList(this.fileCurr, this.fileSize)
                  } else {
                    this.$message({
                      type: 'error',
                      message: data.msg,
                      duration: 1000
                    })
                  }
                  this.loading = false
                }).catch((err) => {
                  this.loading = false
                  console.log(err)
                })
              } else {
                formData.append('fileId', this.form.fileId)
                formData.append('filename', this.form.fileName)

                this.$http({
                  method: 'post',
                  url: this.$api.lift_file_edit,
                  data: formData
                }).then((res) => {
                  let data = res.data

                  if (data.success) {
                    this.$message({
                      message: '编辑电梯文件成功',
                      type: 'success',
                      duration: 1000
                    })
                    this.notBtn()
                    this.getFileList(this.fileCurr, this.fileSize)
                  } else {
                    this.$message({
                      type: 'error',
                      message: data.msg,
                      duration: 1000
                    })
                  }
                  this.loading = false
                }).catch((err) => {
                  this.loading = false
                  console.log(err)
                })
              }
            }
          }
        } else {
          return false
        }
      })
    },
    fileCurrChange (curr) {
      this.getFileList(curr, this.fileSize)
    },
    fileSizeChange (size) {
      this.getFileList(this.fileCurr, size)
    },
    fileType (val) {
      for (let i = 0; i < this.dataTypeList.length; i++) {
        if (val === this.dataTypeList[i].key) {
          return this.dataTypeList[i].value
        }
      }
    },
    createTime (time) {
      if (time === '' || time === null) {
        return '-'
      } else {
        return time.substr(0, 4) + '-' + time.substr(5, 2) + '-' + time.substr(8, 2) + ' ' + time.substr(11, 2) + ':' + time.substr(14, 2) + ':' + time.substr(17, 2)
      }
    },
    njTime (time) {
      if (time === '' || time === null) {
        return '-'
      } else {
        return time.substr(0, 4) + '-' + time.substr(5, 2) + '-' + time.substr(8, 2)
      }
    },
    byTime (time) {
      if (time === '' || time === null) {
        return '-'
      } else {
        return time.substr(0, 4) + '-' + time.substr(5, 2) + '-' + time.substr(8, 2)
      }
    },
    notData (str) {
      return this.$null(str)
    },
    indexMethod (index) {
      // index从0开始
      return index + 1 + (this.fileCurr - 1) * this.fileSize
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.liftDetail
  box-sizing border-box
  padding 80px 20px 60px
  width 100%
  height 100%
  background-color #F5F7FA
  .titleWrap
    width 100%
    height 32px
    .setTitle
      float left
      height 32px
      line-height 32px
      font-weight bold
      font-size 18px
      color #333
    .el-breadcrumb
      float left
      margin-left 20px
      height 32px
      line-height 32px
      font-size 12px
    .myBtn
      float right
  .tableWrap
    margin-top 20px
    padding-left 0px
    padding-right 0px
    background-color #fff
    border-radius 4px
    box-shadow 0 3px 5px 0 rgba(0, 0, 0, .05)
    .select
      float left
      margin-left 20px
      width 160px
    .input
      float left
      margin-left 20px
      width 160px
    .searchBtn
      float left
      margin-left 20px
      padding 5.5px 6px
      font-size 18px
    .list
      margin-top 20px
      &>>>thead
        tr, th
          color #666
          background-color #fafafa
          .cell
              font-weight bold
      &>>>tbody
        tr, th
          color #333
      &>>>td
        padding 7px 0
      .cell
        line-height 26px
      .el-button
          font-size 14px
    .el-pagination
      margin-top 20px
      padding 0 20px 0
      text-align right
  &>>>.el-dialog
    .el-dialog__header
      border-bottom 1px solid #eee
    .el-dialog__body
      max-height 300px
      overflow auto
      .el-form
        width 350px
        .el-select, .el-input
          width 100%
</style>



// WEBPACK FOOTER //
// src/components/village/liftDetail.vue